import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { ConfigProvider, App as AntdApp } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

import App from './App'
import './index.css'
import { useConfigStore } from '@/store/configStore'
import { startEvents } from '@/services/events'

// 设置dayjs中文
dayjs.locale('zh-cn')

// PWA Service Worker 注册由 vite-plugin-pwa 自动处理
// 在构建时会自动注入注册代码到 index.html

// 创建React Query客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5分钟
    },
    mutations: {
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: '#3b82f6',
            colorSuccess: '#10b981',
            colorWarning: '#f59e0b',
            colorError: '#ef4444',
            borderRadius: 8,
            fontSize: 14,
          },
        }}
      >
        {/* Ant Design App Provider：提供 message/notification 语境，避免静态函数警告 */}
        <AntdApp>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Initializer />
        </BrowserRouter>
        </AntdApp>
      </ConfigProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />}
    </QueryClientProvider>
  </React.StrictMode>,
)

function Initializer() {
  const load = useConfigStore((s) => s.load)
  const startAutoRefresh = useConfigStore((s) => s.startAutoRefresh)
  const startSSE = useConfigStore((s) => s.startSSE)
  React.useEffect(() => {
    load()
    startSSE()
    startEvents()
  }, [])
  return <App />
}
